/* WARNING: This file is auto-generated. Do not edit directly.   */
/* To make changes, edit `lib/generators/constants_generator.rb` */
/* To regenerate, run: `rails g constants`                       */

import { ConstantsQuery } from 'queries';

import { LevelEnum } from 'queries';

export const VARSITY = 1;
export const JUNIOR_VARSITY = 2;
export const FRESHMAN = 3;
export const C_TEAM = 4;
export const JUNIOR_COLLEGE = 5;
export const NCAA_D1 = 6;
export const NCAA_D2 = 7;
export const NCAA_D3 = 8;
export const NAIA = 9;
export const FIBA = 10;
export const ADULT = 11;
export const RECREATIONAL = 12;
export const PROFESSIONAL = 13;
export const SEMI_PROFESSIONAL = 14;
export const YOUTH = 15;
export const EIGHTH_GRADE = 16;
export const SEVENTH_GRADE = 17;
export const SIXTH_GRADE = 18;
export const FIFTH_GRADE = 19;
export const FOURTH_GRADE = 20;
export const SEVENTEEN_U = 21;
export const SIXTEEN_U = 22;
export const FIFTHTEEN_U = 23;
export const FOURTEEN_U = 24;

export type LevelType = ConstantsQuery['levels'][number];

const LEVELS: LevelType[] = [
  {
    id: VARSITY,
    name: 'Varsity',
    abbrev: 'V',
    key: LevelEnum.VARSITY
  },
  {
    id: JUNIOR_VARSITY,
    name: 'Junior Varsity',
    abbrev: 'JV',
    key: LevelEnum.JUNIOR_VARSITY
  },
  {
    id: FRESHMAN,
    name: 'Freshman',
    abbrev: 'Fr',
    key: LevelEnum.FRESHMAN
  },
  {
    id: C_TEAM,
    name: 'C Team',
    abbrev: undefined,
    key: LevelEnum.C_TEAM
  },
  {
    id: JUNIOR_COLLEGE,
    name: 'Junior College',
    abbrev: undefined,
    key: LevelEnum.JUNIOR_COLLEGE
  },
  {
    id: NCAA_D1,
    name: 'NCAA D1',
    abbrev: undefined,
    key: LevelEnum.NCAA_D1
  },
  {
    id: NCAA_D2,
    name: 'NCAA D2',
    abbrev: undefined,
    key: LevelEnum.NCAA_D2
  },
  {
    id: NCAA_D3,
    name: 'NCAA D3',
    abbrev: undefined,
    key: LevelEnum.NCAA_D3
  },
  {
    id: NAIA,
    name: 'NAIA',
    abbrev: undefined,
    key: LevelEnum.NAIA
  },
  {
    id: FIBA,
    name: 'FIBA',
    abbrev: undefined,
    key: LevelEnum.FIBA
  },
  {
    id: ADULT,
    name: 'Adult',
    abbrev: undefined,
    key: LevelEnum.ADULT
  },
  {
    id: RECREATIONAL,
    name: 'Recreational',
    abbrev: undefined,
    key: LevelEnum.RECREATIONAL
  },
  {
    id: PROFESSIONAL,
    name: 'Professional',
    abbrev: undefined,
    key: LevelEnum.PROFESSIONAL
  },
  {
    id: SEMI_PROFESSIONAL,
    name: 'Semi-Professional',
    abbrev: undefined,
    key: LevelEnum.SEMI_PROFESSIONAL
  },
  {
    id: YOUTH,
    name: 'Youth',
    abbrev: undefined,
    key: LevelEnum.YOUTH
  },
  {
    id: EIGHTH_GRADE,
    name: '8th Grade',
    abbrev: undefined,
    key: LevelEnum.EIGHTH_GRADE
  },
  {
    id: SEVENTH_GRADE,
    name: '7th Grade',
    abbrev: undefined,
    key: LevelEnum.SEVENTH_GRADE
  },
  {
    id: SIXTH_GRADE,
    name: '6th Grade',
    abbrev: undefined,
    key: LevelEnum.SIXTH_GRADE
  },
  {
    id: FIFTH_GRADE,
    name: '5th Grade',
    abbrev: undefined,
    key: LevelEnum.FIFTH_GRADE
  },
  {
    id: FOURTH_GRADE,
    name: '4th Grade',
    abbrev: undefined,
    key: LevelEnum.FOURTH_GRADE
  },
  {
    id: SEVENTEEN_U,
    name: '17U',
    abbrev: undefined,
    key: LevelEnum.SEVENTEENU
  },
  {
    id: SIXTEEN_U,
    name: '16U',
    abbrev: undefined,
    key: LevelEnum.SIXTEENU
  },
  {
    id: FIFTHTEEN_U,
    name: '15U',
    abbrev: undefined,
    key: LevelEnum.FIFTHTEENU
  },
  {
    id: FOURTEEN_U,
    name: '14U',
    abbrev: undefined,
    key: LevelEnum.FOURTEENU
  }
];

export default LEVELS;
